import { useZendesk } from './useZendesk';
export function ZendeskWidget() {
  useZendesk();
  return null;
}
